import { render, staticRenderFns } from "./addCommunication.vue?vue&type=template&id=7db48102&scoped=true&"
import script from "./addCommunication.vue?vue&type=script&lang=js&"
export * from "./addCommunication.vue?vue&type=script&lang=js&"
import style0 from "./addCommunication.vue?vue&type=style&index=0&id=7db48102&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db48102",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7db48102')) {
      api.createRecord('7db48102', component.options)
    } else {
      api.reload('7db48102', component.options)
    }
    module.hot.accept("./addCommunication.vue?vue&type=template&id=7db48102&scoped=true&", function () {
      api.rerender('7db48102', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/hdcommunication/components/addCommunication.vue"
export default component.exports